const AUTH_STORAGE_KEYS = [
  'user',
  'loginMenu',
  'role',
  'token',
  'deviceId',
  'confvalue',
  'DeliveryFormdata',
  'authenticated',
  'customer',
  'distributor',
  'headerCustomer',
  'SelectedCustomer',
  'materialList',
  'materialListSize',
  'retailerName',
  'fromedit',
  'orderfrom',
  'fromritrival',
  'scheduledData',
  'fromreplicate',
  'ordernumber',
  'showordernumber',
  'isRetrieve',
  'salesPerfomerId',
  'menuNavigationSource'
];

const AUTH_MEMORY_KEYS = new Set([
  'user',
  'loginMenu',
  'role',
  'token',
  'deviceId',
  'confvalue',
  'authenticated',
  'customer',
  'SelectedCustomer',
  'headerCustomer',
  'SelectedLedgerCustomer',
  'SelectedDivLedgerCustomer',
  'distributor',
  'distributorName',
  'retailerName',
  'DeliveryFormdata'
]);
const authMemoryStore = {};
let authStorageShimInstalled = false;
const AUTH_STATE_EVENT = 'suma-auth-state-changed';

export const installAuthStorageShim = () => {
  if (authStorageShimInstalled || typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  authStorageShimInstalled = true;
  const storage = window.localStorage;
  const storagePrototype = Object.getPrototypeOf(storage);
  const nativeGetItem = storagePrototype.getItem;
  const nativeSetItem = storagePrototype.setItem;
  const nativeRemoveItem = storagePrototype.removeItem;
  const nativeClear = storagePrototype.clear;

  ['getItem', 'setItem', 'removeItem', 'clear'].forEach((key) => {
    nativeRemoveItem.call(storage, key);
  });

  AUTH_MEMORY_KEYS.forEach((key) => {
    const existingValue = nativeGetItem.call(storage, key);
    if (existingValue !== null) {
      authMemoryStore[key] = existingValue;
      nativeRemoveItem.call(storage, key);
    }
  });

  Object.defineProperty(storagePrototype, 'getItem', {
    value(key) {
      if (this === storage && AUTH_MEMORY_KEYS.has(key)) {
        return Object.prototype.hasOwnProperty.call(authMemoryStore, key) ? authMemoryStore[key] : null;
      }
      return nativeGetItem.call(this, key);
    },
    configurable: true,
    writable: true
  });

  Object.defineProperty(storagePrototype, 'setItem', {
    value(key, value) {
      if (this === storage && AUTH_MEMORY_KEYS.has(key)) {
        authMemoryStore[key] = String(value);
        nativeRemoveItem.call(storage, key);
        return;
      }
      nativeSetItem.call(this, key, value);
    },
    configurable: true,
    writable: true
  });

  Object.defineProperty(storagePrototype, 'removeItem', {
    value(key) {
      if (this === storage && AUTH_MEMORY_KEYS.has(key)) {
        delete authMemoryStore[key];
        nativeRemoveItem.call(storage, key);
        return;
      }
      nativeRemoveItem.call(this, key);
    },
    configurable: true,
    writable: true
  });

  Object.defineProperty(storagePrototype, 'clear', {
    value() {
      if (this === storage) {
        Object.keys(authMemoryStore).forEach((key) => delete authMemoryStore[key]);
      }
      nativeClear.call(this);
    },
    configurable: true,
    writable: true
  });
};

export const notifyAuthStateChanged = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_STATE_EVENT));
  }
};

export const subscribeAuthState = (handler) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  window.addEventListener(AUTH_STATE_EVENT, handler);
  return () => window.removeEventListener(AUTH_STATE_EVENT, handler);
};

export const PUBLIC_AUTH_PATHS = ['/login', '/forgotpass', '/otpverify', '/reset-password'];

export const isPublicAuthPath = (pathname = window.location.pathname) => PUBLIC_AUTH_PATHS.includes(pathname);

export const hasAuthenticatedUser = () => {
  try {
    const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
    const isFirstLoginPending = storedUser?.isFirstLogin === true || storedUser?.isFirstLogin === 'true';
    return Boolean(storedUser) && !isFirstLoginPending;
  } catch (error) {
    return false;
  }
};

export const clearAuthClientStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  sessionStorage.removeItem('csrfToken');
  sessionStorage.removeItem('firstLoginUserCode');
  notifyAuthStateChanged();
};

export const redirectToLoginIfUnauthenticated = (pathname = window.location.pathname) => {
  if (!isPublicAuthPath(pathname) && !hasAuthenticatedUser()) {
    window.location.replace('/login');
    return true;
  }
  return false;
};

export const installNoStoreMetaTags = () => {
  const metaHeaders = {
    'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
    Pragma: 'no-cache',
    Expires: '0'
  };

  Object.entries(metaHeaders).forEach(([httpEquiv, content]) => {
    let meta = document.querySelector(`meta[http-equiv="${httpEquiv}"]`);
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('http-equiv', httpEquiv);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  });
};
